/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseOnboardingJourney } from '../../models/api-response-onboarding-journey';

export interface Journey$Params {
  companyReference: string;
  limit?: number;
}

export function journey(http: HttpClient, rootUrl: string, params: Journey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOnboardingJourney>> {
  const rb = new RequestBuilder(rootUrl, journey.PATH, 'get');
  if (params) {
    rb.path('companyReference', params.companyReference, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseOnboardingJourney>;
    })
  );
}

journey.PATH = '/v1/api/admin-ui/onboarding-event/{companyReference}/journey';
